import Vue from "vue";

export function index() {
  return Vue.prototype.$http.get(`/lead_providers`);
}
